import styled from "styled-components";

export const DropdownDtpNoMatchingCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  padding: 20px 0px;

  color: var(--tag-stoke-8c, #8c8c8c);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
